import SiteSearchGroup from '../../../components/search-group'
import role from '../../../api/role'
import Add from './add.dialog.vue'
export default {
  components: {
    SiteSearchGroup,
    Add,
  },
  data() {
    return {
      params: {
        outSided: false,
      },
      roles: [],
      path: '',
      isVisable: false,
    }
  },
  watch: {
    //监听相同路由下参数变化的时候，从而实现异步刷新
    $route() {
      this.path = this.$route.path
    },
  },
  mounted() {
    this.path = this.$route.path
    this.getRoles()
  },
  methods: {
    async getRoles() {
      this.roles = await role.get(this.params)
      if (this.roles && this.roles.length) {
        this.$router.push('/system/manage-authority/' + this.roles[0].id)
      }
    },
    add(val) {
      this.isVisable = true
      if (val.id) {
        this.$refs['manage-authority-add'].setParentId(val.id)
      }
    },
    edit(val) {
      this.$refs['manage-authority-add'].getQuery(val.id)
      this.isVisable = true
    },
    del(val) {
      this.$confirm({
        title: 'Are you sure you want to delete this role?',
        content:
          'Please be aware that once this role is deleted, it will never be able to be recovered.',
        type: 'danger',
        icon: 'iconDelete',
        confirmText: 'Delete',
      }).then(async () => {
        await role.del(val.id)
        this.$message.success({
          title: 'Success',
          content: 'This Role has been deleted!',
        })
        this.getRoles()
      })
    },
    confirm() {
      this.getRoles()
      this.isVisable = false
    },
    cancel() {
      this.isVisable = false
    },
  },
}
